/**
 * Agent Page - Main page for agent conversation management
 */

import React, { useState } from "react";
import { Row, Col, Typography, Alert } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { AgentProvider, useAgent } from "./context/AgentContext.jsx";
import ConversationList from "./components/ConversationList.jsx";
import QueuePanel from "./components/QueuePanel.jsx";
import ConversationChat from "./components/ConversationChat.jsx";

const { Title } = Typography;

const AgentPageContent = () => {
  const { error, clearError, loadConversation, clearCurrentConversation } =
    useAgent();
  const [selectedConversation, setSelectedConversation] = useState(null);

  const handleSelectConversation = (conversation) => {
    setSelectedConversation(conversation);
    loadConversation(conversation.id);
  };

  const handleCloseChat = () => {
    setSelectedConversation(null);
    clearCurrentConversation();
  };

  return (
    <div style={{ padding: "24px" }}>
      <Title level={2}>
        <MessageOutlined /> Agent Conversations
      </Title>

      {error && (
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
          closable
          onClose={clearError}
          style={{ marginBottom: 16 }}
        />
      )}

      <Row gutter={[16, 16]} style={{ minHeight: "calc(100vh - 200px)" }}>
        {/* On tablets (md), use two columns to avoid cramping; on desktop, use three */}
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <QueuePanel />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <ConversationList onSelectConversation={handleSelectConversation} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
          {selectedConversation ? (
            <ConversationChat
              conversation={selectedConversation}
              onClose={handleCloseChat}
            />
          ) : (
            <div style={{ padding: 16, color: "#999" }}>
              Select a conversation to view chat
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

const AgentPage = () => {
  return (
    <AgentProvider>
      <AgentPageContent />
    </AgentProvider>
  );
};

export default AgentPage;
